import { Component, Input, OnInit } from '@angular/core';
import { ApThreadMessageDto, IColor } from 'webcommon/shared';
import { ApBaseComponent } from 'webcommon/core-ui';
import { BorderDirection } from 'webcommon/core-ui';

@Component({
  selector: 'ap-message-thread-message',
  styleUrls: ['./ap-message-thread-message.component.less'],
  templateUrl: './ap-message-thread-message.component.html',
})
export class ApMessageThreadMessageComponent extends ApBaseComponent implements OnInit {
  @Input() baseId?: string;
  @Input() message: ApThreadMessageDto;

  Id: string;

  isCollapsed = false;

  borderColor: IColor;
  borderDirection: BorderDirection;

  constructor() {
    super();
  }

  ngOnInit() {
    this.loading = true;
    this.setId();
    this.load();
  }

  private load() {
    this.isCollapsed = this.message.IsRead;
    this.borderColor = { Color: this.message.UrgencyHtmlColor ? '#' + this.message.UrgencyHtmlColor : '' };
    this.borderDirection = BorderDirection.Top;
    this.loading = false;
  }

  private setId() {
    this.Id = `${this.baseId}-message-${this.message.MessageThreadId}`;
  }
}
